module.exports = __webpack_public_path__ + "img/img_guoqing.3570436a.png";